import React from 'react';
import PropTypes from 'prop-types';

import Property from './Property';
import ApiExample from './ApiExample';

// Presentational Component
const Request = ({ request }) => {
	return (
		<div className="request">
			<div>
				<div className="prop-heading">
					<h4>Request</h4>
					<ApiExample apiItem={request} />
				</div>
				<div className="properties">
					{request.fields
						.map(field => <Property key={field.name} field={field} />)
					}
				</div>
				<br />
			</div>
		</div>
	);
};

Request.propTypes = {
	request: PropTypes.object.isRequired
};

export default Request;


// WEBPACK FOOTER //
// ./src/components/api/Request.js